import algoliasearch from 'algoliasearch/lite';

const searchClient = algoliasearch(
  'SF44VDBM4X',
  '6c771cb2cc3cdbc88f093f7b76231e7d'
);

const index = searchClient.initIndex('shopify_products');

export { searchClient, index };
